import { formatTime } from "../hooks/useClock";

// What the Notes window holds. Only the resume opens; the rest are jokes that stay locked.
// `daysAgo` places each note in the list's date groups (Today, Yesterday, Previous 7 Days...).

export const NOTES = [
  { id: "resume", title: "My resume", preview: "Sylvester Asare Sarpong, Software Engineer", daysAgo: 0, shared: true },
  {
    id: "secret",
    title: "Secret Stuff",
    preview: "My notes app doesn't look like this, I just made some creative choices",
    daysAgo: 1,
  },
  { id: "thoughts", title: "My thoughts on random stuff", preview: "Not deep but deep(don't take them serious)", daysAgo: 3 },
  { id: "tapes", title: "The Lost Tapes 2", preview: "His best one(I think or maybe I'm wrong)", daysAgo: 6 },
  {
    id: "kyle",
    title: "Kyle XY Season 4 Script",
    preview: "If the producers aren't gonna finish, I will do it myself",
    daysAgo: 12,
  },
  { id: "thanos", title: "Thanos' Shopping List", preview: "He shops for the same stuff I do", daysAgo: 19 },
  { id: "phase4", title: "Phase 4 plans", preview: "FYI your fav superhero didn't make the cut", daysAgo: 27 },
  {
    id: "kanye",
    title: "100+ reasons Why Kanye is the GOAT",
    preview: "If you don't agree after the first five points you are just a hater",
    daysAgo: 41,
  },
  { id: "conspiracy", title: "Conspiracy Theories", preview: "I went to Area 51(It's called Site 15)", daysAgo: 58 },
  { id: "c137", title: "C-137 is home", preview: "Doesn't mean explaination but I will anyway", daysAgo: 73 },
  { id: "anime", title: "Anime is mid(Spirited Away is great tho)", preview: "A hater's guide to anime", daysAgo: 96 },
  {
    id: "mail",
    title: "If you've read all the above send me a mail.",
    preview: "Hit me up, you can find my email in my resume.",
    daysAgo: 130,
  },
];

// Sidebar folders. `notes` picks which notes a folder shows.
export const FOLDERS = [
  { id: "quick", title: "Quick Notes", icon: "quicknote", notes: () => [] },
  { id: "shared", title: "Shared", icon: "shared", notes: (all) => all.filter((n) => n.shared) },
  { id: "notes", title: "Notes", icon: "folder", section: "iCloud", notes: (all) => all },
];

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// The date group a note falls in, as Notes names them.
export const dateGroup = (date, now) => {
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(now) - startOfDay(date)) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days <= 7) return "Previous 7 Days";
  if (days <= 30) return "Previous 30 Days";
  if (date.getFullYear() === now.getFullYear()) return MONTHS[date.getMonth()];
  return String(date.getFullYear());
};

// Each note with its date: the resume from a few minutes ago, the rest `daysAgo` days back
// (an hour apart, so notes from the same day keep their order).
export const datedNotes = (now) =>
  NOTES.map((n, i) => ({
    ...n,
    date: new Date(now.getTime() - (n.daysAgo ? n.daysAgo * 86400000 + i * 3600000 : 4 * 60000)),
  }));

// Notes (newest first) split into their date groups, in order: [{ name, notes }].
export const groupByDate = (notes, now) =>
  notes.reduce((acc, note) => {
    const name = dateGroup(note.date, now);
    const last = acc[acc.length - 1];
    if (last && last.name === name) last.notes.push(note);
    else acc.push({ name, notes: [note] });
    return acc;
  }, []);

// The date shown in a list row: the time today (9:41 PM), "Yesterday", then 12/10/2026.
export const rowDate = (date, now) => {
  const group = dateGroup(date, now);
  if (group === "Today") return formatTime(date);
  if (group === "Yesterday") return "Yesterday";
  return date.toLocaleDateString("en-GB");
};
